<div class="main-content">
    <div class="container-fluid">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header card-header-danger">
                    <h4 class="card-title">Action Plan</h4>
                </div>
                <div class="card-body">
                    <form #searchForm="ngForm" (ngSubmit)="Search()" class="form">
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field>
                                    <input matInput [matDatepicker]="startdate" [min]="createdate" [max]="today" name="startdate" required 
                                        [(ngModel)]="form.startdate" #startdateInput="ngModel" placeholder="Start Date">
                                    <mat-datepicker-toggle matSuffix [for]="startdate"></mat-datepicker-toggle>
                                    <mat-datepicker #startdate></mat-datepicker>
                                    <mat-error
                                        *ngIf="startdateInput.invalid && (startdateInput.dirty || startdateInput.touched)">
                                        Start Date is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field>
                                    <input matInput [matDatepicker]="enddate" name="enddate" [min]="createdate" [max]="today"  required
                                        [(ngModel)]="form.enddate" #enddateInput="ngModel" placeholder="End Date">
                                    <mat-datepicker-toggle matSuffix [for]="enddate"></mat-datepicker-toggle>
                                    <mat-datepicker #enddate></mat-datepicker>
                                    <mat-error
                                        *ngIf="enddateInput.invalid && (enddateInput.dirty || enddateInput.touched)">
                                        End Date is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <label>Module Name <span class="red">*</span></label>
                                <ng-select class="form-control" [items]="clientmodule" [multiple]="false"
                                    bindLabel="name" bindValue="id" required [(ngModel)]="form.moduleid" name="moduleid"
                                    #moduleId="ngModel" (change)="getcatbymodule($event.id)">
                                </ng-select>
                                <mat-error *ngIf="moduleId.invalid && (moduleId.dirty || moduleId.touched)">
                                    Module Name is required
                                </mat-error>
                            </div>
                            <div class="col-md-6">
                                <label>Branch Name <span class="red">*</span></label>
                                <ng-select class="form-control" [items]="Branches" [multiple]="false" bindLabel="name"
                                    bindValue="id" required [(ngModel)]="form.branchid" name="branchid"
                                    #branchId="ngModel">
                                </ng-select>
                                <mat-error *ngIf="branchId.invalid && (branchId.dirty || branchId.touched)">
                                    Branch Name is required
                                </mat-error>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <label>Departments <span class="red">*</span> </label>
                                <ng-select class="form-control" [items]="Departments" [multiple]="false"
                                    bindLabel="name" bindValue="id" required [(ngModel)]="form.departmentid"
                                    name="departmentid" #departmentId="ngModel"  (change)="getAssignerbyDepartment($event.id)">
                                </ng-select>
                                <mat-error *ngIf="departmentId.invalid && (departmentId.dirty || departmentId.touched)">
                                    Department is required
                                </mat-error>
                            </div>
                            <div class="col-md-6">
                                <label>Assigner</label>
                                <ng-select class="form-control" [items]="allassigner" [multiple]="false"
                                    bindLabel="name" bindValue="id" [(ngModel)]="form.assignerid" name="assignerid">
                                </ng-select>

                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <label>Status</label>
                                <ng-select class="form-control" [items]="Stats" [multiple]="false" bindLabel="name"
                                    bindValue="value" [(ngModel)]="form.state" name="state">
                                </ng-select>

                            </div>
                        </div>
                        <button mat-raised-button type="submit" class="btn primary pull-right mt-4"
                            [disabled]="searchForm.invalid">Search</button>
                        <button mat-raised-button type="button" class="btn secondary pull-right mt-4"
                            (click)="clear()">Clear</button>
                    </form>
               
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <mat-form-field >
                                <input matInput placeholder="Filter......."  (keyup)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                   
                    </div>
                </div>

            </div>

         

          

        

            <div class="row">
                <div class="container-fluid">
                    <ng-container *ngFor="let item of ActionPlanData; let i = index">
                        <mat-accordion style="margin:5px; text-align: center; color: black;" matBadgeColor="accent"
                            class="example-headers-align">
                            <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <span class="text-truncate" style="max-width: 330px; border-radius: 5px; padding: 5px;">{{item.question_name_en}}
                                            ?</span>

                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <span>{{item?.assignrname}}</span>
                                        <span style=" border-radius: 5px; padding: 5px;">Date : {{item.date | date:'yyyy-MM-dd'}}</span>
                                        <span *ngIf="item.assigneranswerdate" class="text-success">Answerd Date : {{item.assigneranswerdate}}</span>
                                        <span style=" border-radius: 5px; padding: 5px;">Due Date:
                                            {{item.duedate}}</span>
                                        <span
                                            style="background-color: #c13e33; border-radius: 5px; padding: 5px; color: white;">Score
                                            :{{item.score}}</span>
                                        <div style="margin-right: 15px;" class="mt-2">
                                            <mat-icon *ngIf="item.done=='true'" class="d-inline"
                                                style="color: green; font-size: 30px;">done_all</mat-icon>
                                            <!-- <mat-icon *ngIf="item.done=='NotDone'" style="color: rgb(250, 153, 6); font-size: 30px;">remove_done</mat-icon>   -->
                                            <mat-icon *ngIf="item.done=='false'" class="d-inline"
                                                style="color: rgb(250, 7, 7); font-size: 30px;">report</mat-icon>
                                        </div>
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <ng-container>
                                    <!-- <div class="row">
                              <p>         <label>Question :</label>  {{item.question_name_en}} ?</p>
                                    </div> -->
                                    <div class="question-section">
                                        <h3 class="section-title">
                                          <mat-icon class="section-icon">help_outline</mat-icon>
                                          Question
                                        </h3>
                                        <p class="question-content">
                                          <span class="blockquote">{{item.question_name_en}} ?</span>
                                        </p>
                                      </div>
                                    <div class="row">
                                        <div class="col-6" [ngClass]="{'col-6': item.done=='true', 'col-12': item.done=='false'}">
                                            <h5>
                                                <!-- <mat-icon class="section-icon">help_outline</mat-icon> -->
                                                By : {{item.auditername}}
                                              </h5>
                                            <!-- <span>By : {{item.auditername}}</span> -->
                                            <div>
                                                <ul *ngFor="let item of item.englishansweredchoices  let i = index">
                                                    <li class="text-left">{{item}}</li>
                                                </ul>
                                                <div class="row">
                                                    <div class="col-md-2"
                                                        *ngFor="let item2 of item.photosurl; let i = index">
                                                        <img style="height: 100px;" src="{{item2.url}}"
                                                            class="img-thumbnail" (click)="open(item2.url)" />
                                                    </div>
                                                </div>
                                                <!-- <div class="row">

                                                    <p class="mt-4"> <label>Auditor Comment:</label> {{item.comment}}
                                                    </p>
                                                </div> -->
                                                <div class="comment-section" *ngIf="item.comment">
                                                    <h3 class="section-title">
                                                      <mat-icon class="section-icon">comment</mat-icon>
                                                       Auditer  Comment
                                                    </h3>
                                                    <p class="comment-content blockquote" >
                                                    {{item.comment}}
                                                    </p>
                                                  </div>
                                            </div>

                                        </div>
                                        <div *ngIf="item.done=='true'" class="col-6 text-center borderL">
                                            <h5 >
                                                <!-- <mat-icon class="section-icon">help_outline</mat-icon> -->
                                                By Assigner
                                              </h5>
                                            <!-- <span >By Assigner</span> -->
                                            <div *ngFor="let item2 of item.assigneranswerurl; let i = index">
                                                <img style="height: 100px;" src="{{item2}}" class="img-thumbnail mt-4"
                                                    (click)="open(item2)" />
                                            </div>
   
                                            <div class="comment-section mt-4" *ngIf="item.assigneranswercomment">
                                                <h3 class="section-title">
                                                  <mat-icon class="section-icon">comment</mat-icon>
                                                  Assigner Comment :
                                                </h3>
                                                <p class="comment-content blockquote" >
                                                {{item.assigneranswercomment}}
                                                </p>
                                              </div>
                                        </div>

                                    </div>

                                </ng-container>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>